import { graphql } from "gql";
import request from "graphql-request";
import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

const mutationSetRolesFn = (
    accessToken: string, 
    data: {
        userId: number,
        roles: string[]
    }
) =>

    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: mutationQuery,
        variables: {
            userId: data.userId,
            roles: data.roles
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data) {
            return data;  
        }
        throw new Error("Error setting role");
    })
    .catch((error) => {
        console.error("GraphQL Error:", error);
        throw error; 
    });

    const mutationQuery = graphql(`
        mutation setRoles ($userId: Int!, $roles: [String!]!) {
            setRoles(userId: $userId, roles: $roles){
                userId
                roles
            }
        }
    `);

export default mutationSetRolesFn;